var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
var StepControlsWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  background: #fff;\n  padding: 20px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  background: #fff;\n  padding: 20px;\n"])));
export default StepControlsWrapper;
var templateObject_1;
